import {faPlus, faXmark} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import {FormikState} from 'formik'
import React, {FC, Fragment, useEffect, useState} from 'react'
import { Button, OverlayTrigger } from 'react-bootstrap'
import CopyToClipboard from 'react-copy-to-clipboard'
import {
  MORE_MAPPING_FORM_DATA,
  MORE_TEMPLATE_DATA,
  MORE_TEMPLATE_DATA_ON_GET,
  MoreFieldMappingItem,
  MoreMapping_Item_On_Get,
  PLATFORM_FIELD_DATA,
} from 'src/interfaces/Template.interface'
import {getPlatformFieldsAsync} from 'src/redux/actions/productActions'
import {getPlatformParentFieldDataCategoriesAsync, getShortCodeAsync} from 'src/redux/actions/templateAndPricingActions'
import {useAppDispatch, useAppSelector} from 'src/redux/storeHooks'
import MappingMultilineHtmlEditor from './MappingMultilineHtmlEditor'
import AddNewAttributeValueModal from './AddNewAttributeValueModal'
import CategoryAttributeForSelect from './CategoryAttributeForSelect'
import MoreAttributeForSelect from './MoreAttributeForSelect'
import { SectionHeaderLabel } from './SectionHeaderInfoTooltip'
import Select from 'react-select';
import { isEmptyAttributeSelectValue } from '../utils/quicklistMoreMappingUtils'
import ListingProfileFieldSearchSelect from './ListingProfileFieldSearchSelect'
import {
  mappingOptionFromSavedField,
  optionFromSavedMappingRef,
  sameMiscOptionId,
  withSavedSelectOption,
} from './utils/miscMappingHydrate'

type OPTION_TYPE = 'NATIVE' | 'CUSTOM' | 'DEFAULT'

const isDefaultTextValueInput = (inputType?: string) =>
  inputType === 'TEXT' || inputType === 'BOOLEAN'
type LocationField = {
  input_type: string;
  name: string;
  href: string | null;
  display_name: string;
  is_required: boolean;
};
type TemplateMappingItemPropsType = {
  handleRemoveRow: (index: number, templateDataId:number|null) => void
  setFieldValue: (field: string, value: any) => void
  closeModal: () => void
  categoryAttributes: MoreFieldMappingItem
  index: number
  values: MORE_MAPPING_FORM_DATA
  handleChange: (e: string | React.ChangeEvent<any>) => void
  handleValueTextChange: (attributeId: number, value: string) => void
  selectedTextValues: {[key: number]: string | null}
  selectedFieldValues: {[key: number]: number}
  rowData: MORE_TEMPLATE_DATA
  setFormikState: (
    f:
      | FormikState<MORE_MAPPING_FORM_DATA>
      | ((prevState: FormikState<MORE_MAPPING_FORM_DATA>) => FormikState<MORE_MAPPING_FORM_DATA>),
    cb?: (() => void) | undefined
  ) => void
  moreTemplateItemData: MoreMapping_Item_On_Get | null
  moreTemplateItemDataUnderMap: MORE_TEMPLATE_DATA_ON_GET | null
  deletingTemplateData:boolean
  openAddNewAttributeValueModal: boolean
  setOpenAddNewAttributeValueModal: React.Dispatch<React.SetStateAction<boolean>>
  allowDataInsertion?: boolean
  insertionPayload?: LocationField[] | []
  fieldDataRefreshKey?: number
  nativeFields?: any[]
  customFields?: any[]
  listingProfileGridLayout?: boolean
  suppressColumnHeaders?: boolean
  fieldRequired?: boolean
  showAddNewValueButton?: boolean
  onAddNewValueClick?: () => void
  showMultiAddNewButton?: boolean
  onMultiAddNewClick?: () => void
}

const legacyMappedFieldSelectStyles = {
  control: (base: Record<string, unknown>, state: { isFocused: boolean }) => ({
    ...base,
    minHeight: '30px',
    height: '30px',
    borderColor: state.isFocused ? '#212529' : (base.borderColor as string),
    boxShadow: 'none',
    '&:hover': { borderColor: '#212529' },
  }),
  placeholder: (base: Record<string, unknown>) => ({
    ...base,
    color: '#212529',
    fontSize: '13px',
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (base: Record<string, unknown>) => ({
    ...base,
    color: '#212529',
    padding: '4px',
    '& svg': {
      width: '20px',
      height: '18px',
    },
  }),
  clearIndicator: (base: Record<string, unknown>) => ({
    ...base,
    padding: '4px',
    color: '#212529',
    '&:hover': { color: '#212529' },
  }),
  valueContainer: (base: Record<string, unknown>) => ({
    ...base,
    height: '30px',
    padding: '0 6px',
  }),
  input: (base: Record<string, unknown>) => ({
    ...base,
    margin: '0px',
    padding: '0px',
  }),
  singleValue: (base: Record<string, unknown>) => ({
    ...base,
    color: '#212529',
    fontSize: '13px',
  }),
}

const TemplateMappingItem: FC<TemplateMappingItemPropsType> = ({
  closeModal,
   setFieldValue,
  handleRemoveRow,
  categoryAttributes,
  index,
  values,
  handleChange,
  handleValueTextChange,
  selectedTextValues,
  selectedFieldValues,
  rowData,
  setFormikState,
  moreTemplateItemData,
  moreTemplateItemDataUnderMap,
  deletingTemplateData,
  openAddNewAttributeValueModal,
  setOpenAddNewAttributeValueModal,
  allowDataInsertion,
  insertionPayload,
  fieldDataRefreshKey,
  nativeFields,
  customFields,
  listingProfileGridLayout = false,
  suppressColumnHeaders = false,
  fieldRequired = false,
  showAddNewValueButton = false,
  onAddNewValueClick,
  showMultiAddNewButton = false,
  onMultiAddNewClick,
}) => {
  const savedMappedField =
    moreTemplateItemDataUnderMap?.mapped_field ?? moreTemplateItemData?.mapped_field
  const [attributeMappingOptions, setAttributeMappingOptions] = useState<OPTION_TYPE>(() =>
    mappingOptionFromSavedField(savedMappedField)
  )

  const dispatch = useAppDispatch()
  const {mainStoreData, erpStoreData, omsStoreData, accountingStoreData, shippingStoreData, ticketStoreData, fetchedSourcePlatformData, fetchedConnectedPlatformData} = useAppSelector((state) => state.fetchConnectedPlatform) || {}
  const apiSource = fetchedSourcePlatformData?.source_platform
  const sourceStore = apiSource?.id
    ? apiSource
    : mainStoreData ?? omsStoreData ?? erpStoreData ?? accountingStoreData ?? shippingStoreData ?? null
  const sourceStoreId = sourceStore?.id

  const [fieldData, setFieldData] = useState<any[]>(() =>
    Array.isArray(nativeFields) ? nativeFields : []
  )
  const [fieldDataCustom, setFieldDataCustom] = useState<any[]>(() =>
    Array.isArray(customFields) ? customFields : []
  )
  const [dataSetLoading, setDataSetLoading] = useState<boolean>(false)
  const [platformFieldDataSet, setPlatformFieldDataSet] = useState<PLATFORM_FIELD_DATA[] | []>([])
  const [shortCode, setShortCode] = useState([])
  const [copyMarkup, setCopyMarkup] = useState<boolean>(false)
  const [buttonString, setButtonString] = useState('');
  const [shortCodeVisibility, setShortCodeVisibility] = useState(false);
  const [selectedValues, setSelectedValues] = useState<{[key: number]: number | null}>({})
  const handleCopyMarkup = (data: string, identifier: string) => {
      setCopyMarkup(true)
      setButtonString(data)
  };

  const handleShortCode = async (input: string) => {
    try {
      const response = await dispatch(
        getShortCodeAsync({ shortcode_type: 'PRODUCT_SC', search_string: input })
      );
      if (response.payload) {
        setShortCode(response.payload?.results);
        setShortCodeVisibility(true)
      }
    } catch (error) {
      console.error('Error fetching short codes:', error);
    }
  };

  const handleMappingOptionChange = (mappedIndex: number, option: any) => {
    setAttributeMappingOptions(option)

    if (option === 'NATIVE' || option === 'CUSTOM') {
      const fieldType = option === 'CUSTOM' ? 'CUSTOM' : 'NATIVE'
      
      // Use props if available
      if (nativeFields && customFields) {
        if (fieldType === 'NATIVE') {
          setFieldData(nativeFields)
        } else {
          setFieldDataCustom(customFields)
        }
      } else {
        setDataSetLoading(true)
        const sourceStore = apiSource?.id ? apiSource : mainStoreData ?? omsStoreData ?? erpStoreData ?? accountingStoreData ?? shippingStoreData ?? null
        if (!sourceStore?.id) {
          setDataSetLoading(false)
          return
        }
        dispatch(
          getPlatformFieldsAsync({
            platformId: sourceStore.id,
            otherParams: {field_type: fieldType, includeLocalFields: option === 'NATIVE', owner: 'PRODUCT'},
          })
        ).then((response) => {
          if (fieldType === 'NATIVE') {
            setFieldData(response.payload)
            setDataSetLoading(false)
          } else {
            setFieldDataCustom(response.payload)
            setDataSetLoading(false)
          }
        })
      }
    }

    // Reset the mutually exclusive fields when mapping type changes
    let templateDataMappingShadow = [...values.template_data]
    if (mappedIndex === 0) {
      if (option === 'DEFAULT') {
        setFieldValue('mapped_field', null)
        setFieldValue('value', null)
        setFieldValue('value_str', '')
        setFormikState((pre) => {
          const initialTemplateRow = pre.values.template_data?.[0]
          return {
            ...pre,
            values: {
              ...pre.values,
              mapped_field: null,
              value: null,
              value_str: '',
              template_data: [
                {
                  id: initialTemplateRow?.id ?? null,
                  mapped_field: null,
                  value: null,
                  value_str: '',
                },
              ],
            },
          }
        })
      } else {
        // Switching to a mapped field should drop any default value
        setFieldValue('value', null)
        setFieldValue('value_str', '')
        templateDataMappingShadow[mappedIndex] = {
          id: templateDataMappingShadow[mappedIndex].id,
          mapped_field: null,
          value: null,
          value_str: '',
        }
        setFormikState((pre) => {
          return {...pre, values: {...pre.values, template_data: templateDataMappingShadow}}
        })
      }
    } else {
      templateDataMappingShadow[mappedIndex] = {
        id: templateDataMappingShadow[mappedIndex].id,
        mapped_field: null,
        value: null,
        value_str: '',
      }
      setFormikState((pre) => {
        return {...pre, values: {...pre.values, template_data: templateDataMappingShadow}}
      })
    }
  }

  useEffect(() => {
    if (
      (categoryAttributes && categoryAttributes.input_type === 'MULTI_INSTANCE_SELECT') || (categoryAttributes && categoryAttributes.input_type === 'MULTISELECT') ||
      (categoryAttributes && categoryAttributes.input_type === 'SELECT')
    ) {
      setDataSetLoading(true)
      dispatch(
        getPlatformParentFieldDataCategoriesAsync({
          platform_Id: categoryAttributes.id!,
        })
      )
        .then((response) => {
          setPlatformFieldDataSet(response.payload)
          setDataSetLoading(false)
        })
        .catch(() => {
          setDataSetLoading(false)
        })
    }
  }, [categoryAttributes, fieldDataRefreshKey])

  //under mapping case fill the values with their field type

  useEffect(() => {
    if (moreTemplateItemDataUnderMap?.mapped_field && sourceStoreId) {
      if (
        moreTemplateItemDataUnderMap.mapped_field.field_type === 'LOCAL' ||
        moreTemplateItemDataUnderMap.mapped_field.field_type === 'NATIVE'
      ) {
        setAttributeMappingOptions('NATIVE')
        
        if (Array.isArray(nativeFields)) {
          if (nativeFields.length > 0) setFieldData(nativeFields)
        } else {
          setDataSetLoading(true)
          dispatch(
            getPlatformFieldsAsync({
              platformId: sourceStoreId,
              otherParams: {
                field_type: moreTemplateItemDataUnderMap.mapped_field.field_type,
                includeLocalFields: true,
                owner: 'PRODUCT',
              },
            })
          ).then((response) => {
            setFieldData(response.payload)
            setDataSetLoading(false)
          })
        }
      } else {
        setAttributeMappingOptions('CUSTOM')
        
        if (Array.isArray(customFields)) {
          if (customFields.length > 0) setFieldDataCustom(customFields)
        } else {
          dispatch(
            getPlatformFieldsAsync({
              platformId: sourceStoreId,
              otherParams: {field_type: moreTemplateItemDataUnderMap.mapped_field.field_type, owner: 'PRODUCT'},
            })
          ).then((response) => {
            setFieldDataCustom(response.payload)
          })
        }
      }
    }
  }, [moreTemplateItemDataUnderMap, nativeFields, customFields])

  useEffect(() => {
    if (moreTemplateItemData?.mapped_field && sourceStoreId) {
      if (
        moreTemplateItemData.mapped_field.field_type === 'LOCAL' ||
        moreTemplateItemData.mapped_field.field_type === 'NATIVE'
      ) {
        setAttributeMappingOptions('NATIVE')
        if (Array.isArray(nativeFields)) {
          if (nativeFields.length > 0) {
            setFieldData(nativeFields)
            setDataSetLoading(false)
          }
        } else {
          setDataSetLoading(true)
          dispatch(
            getPlatformFieldsAsync({
              platformId: sourceStoreId,
              otherParams: {
                field_type: moreTemplateItemData.mapped_field.field_type,
                includeLocalFields: true,
                owner: 'PRODUCT',
              },
            })
          ).then((response) => {
            setFieldData(response.payload)
            setDataSetLoading(false)
          })
        }
      } else {
        setAttributeMappingOptions('CUSTOM')
        if (Array.isArray(customFields)) {
          if (customFields.length > 0) {
            setFieldDataCustom(customFields)
            setDataSetLoading(false)
          }
        } else {
          dispatch(
            getPlatformFieldsAsync({
              platformId: sourceStoreId,
              otherParams: {field_type: moreTemplateItemData.mapped_field.field_type, owner: 'PRODUCT'},
            })
          ).then((response) => {
            setFieldDataCustom(response.payload)
            setDataSetLoading(false)
          })
        }
      }
    }
  }, [moreTemplateItemData?.mapped_field, moreTemplateItemData?.value, nativeFields, customFields])
  const handleValueChange = (attributeId: number, value: number | null) => {
    if (value === null || value === undefined) {
      setFieldValue('value', null)
      setSelectedValues((prevValues) => ({
        ...prevValues,
        [attributeId]: null,
      }))
      return
    }

    setFieldValue('value', value)
    setSelectedValues((prevValues) => ({
      ...prevValues,
      [attributeId]: value,
    }))
    // Call constructPayloadAttribute when attribute value changes
    // constructPayloadAttribute(mappingOptions, selectedTextValues, selectedValues, selectedFieldValues);
  }

  /** Placeholder option ("Select ITEM_ATTRIBUTES") must store null, not the label text. */
  const handleAttributeSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (isEmptyAttributeSelectValue(e.target.value)) {
      setFieldValue(e.target.name, null)
      if (e.target.name === 'value' || e.target.name.endsWith('.value')) {
        setFieldValue('value', null)
      }
      if (e.target.name === 'mapped_field' || e.target.name.endsWith('.mapped_field')) {
        setFieldValue('mapped_field', null)
      }
      return
    }
    handleChange(e)
  }

  const mappingFields = attributeMappingOptions === 'NATIVE' ? fieldData : fieldDataCustom
  const savedMappedFieldForRow =
    index === 0
      ? moreTemplateItemData?.mapped_field ?? moreTemplateItemDataUnderMap?.mapped_field
      : moreTemplateItemDataUnderMap?.mapped_field
  const selectedMappedId = index === 0 ? values.mapped_field : rowData?.mapped_field
  const mappedFieldOptions = withSavedSelectOption(
    Array.isArray(mappingFields)
      ? [...mappingFields]
          .filter(Boolean)
          .sort((a, b) =>
            (a?.display_name ?? '').localeCompare(b?.display_name ?? '', undefined, {sensitivity: 'base'})
          )
          .map((field) => ({
            value: Number(field.id),
            label: field.display_name ?? '',
          }))
      : [],
    optionFromSavedMappingRef(savedMappedFieldForRow),
    selectedMappedId
  )
  const savedValueField =
    index === 0
      ? moreTemplateItemData?.value ?? moreTemplateItemDataUnderMap?.value
      : moreTemplateItemDataUnderMap?.value
  const selectedValueId = index === 0 ? values?.value : rowData?.value
  const platformValueOptions = withSavedSelectOption(
    Array.isArray(platformFieldDataSet)
      ? platformFieldDataSet.map((field) => ({
          value: Number(field.id),
          label: field.api_name ?? field.display_name ?? '',
        }))
      : [],
    optionFromSavedMappingRef(savedValueField),
    selectedValueId
  )

  const isMultilineValueField = ['MULTILINE_TEXT', 'MULTILINETEXT'].includes(
    categoryAttributes.input_type
  )

  const valueFieldWrapClass = (legacyWrapperClass: string) =>
    listingProfileGridLayout
      ? clsx(
          'product-listing__more-mapping-value-field',
          isMultilineValueField && 'product-listing__more-mapping-value-field--multiline'
        )
      : legacyWrapperClass

  const mappingTypeSelectClass = clsx(
    'form-select flex-grow-1',
    listingProfileGridLayout && 'product-listing__more-mapping-control'
  )

  const valueControlClass = (baseClass: string) =>
    clsx(baseClass, listingProfileGridLayout && 'product-listing__more-mapping-control')

  const showMultiAddNewOnThisRow =
    listingProfileGridLayout &&
    showMultiAddNewButton &&
    index === 0 &&
    Boolean(onMultiAddNewClick)

  const renderMappedFieldSearch = (
    selectProps: {
      name: string
      value: unknown
      placeholder: string
      disabled?: boolean
      onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
      wrapClass?: string
    }
  ) => {
    const selected = mappedFieldOptions.find((opt) => sameMiscOptionId(opt.value, selectProps.value))
    const fieldType = attributeMappingOptions === 'CUSTOM' ? 'CUSTOM' : 'NATIVE'
    return (
      <ListingProfileFieldSearchSelect
        key={`${selectProps.name}-${fieldType}`}
        name={selectProps.name}
        platformId={sourceStoreId}
        fieldType={fieldType}
        value={selectProps.value}
        selectedLabel={selected?.label ?? null}
        placeholder={selectProps.placeholder}
        disabled={selectProps.disabled}
        onChange={selectProps.onChange}
        className={valueControlClass(
          selectProps.wrapClass ?? 'form-select d-flex flex-wrap flex-grow-1'
        )}
      />
    )
  }

  return (
    <div
      className={clsx(
        'row w-100 mb-3',
        ['MULTILINE_TEXT', 'MULTILINETEXT'].includes(categoryAttributes.input_type)
          ? ''
          : 'align-items-center',
        listingProfileGridLayout && 'product-listing__more-mapping-grid-row',
        listingProfileGridLayout && index > 0 && 'product-listing__more-mapping-grid-row--continued'
      )}
    >
      {!suppressColumnHeaders && !listingProfileGridLayout ? (
        <div className='mb-3 row fs-6 form-label'>
          <div className='col-sm-3 col-6'>Attribute Name</div>
          <div className='col-sm-3 col-6'>Mapping Type</div>
          <div className='col-sm-6 col-12 ps-5'>Attribute Value</div>
        </div>
      ) : null}
      <div
        className={clsx(
          'col-sm-3 col-6',
          listingProfileGridLayout && 'product-listing__more-mapping-grid-name',
          listingProfileGridLayout && index > 0 && 'product-listing__more-mapping-grid-skip'
        )}
      >
        {listingProfileGridLayout ? (
          <SectionHeaderLabel
            title={categoryAttributes.display_name}
            tooltip={categoryAttributes.description || undefined}
            tooltipId={`more-mapping-attribute-${categoryAttributes.id}`}
            required={fieldRequired}
            requiredVariant="spell"
            requiredBadgeStyle="pill"
          />
        ) : (
          <label className="form-label flex-shrink-0 mb-0">
            <SectionHeaderLabel
              title={categoryAttributes.display_name}
              tooltip={categoryAttributes.description || undefined}
              tooltipId={`more-mapping-attribute-${categoryAttributes.id}`}
              required={fieldRequired}
              requiredVariant="spell"
              requiredBadgeStyle="pill"
            />
          </label>
        )}
        {listingProfileGridLayout && showAddNewValueButton && index === 0 && onAddNewValueClick ? (
          <Button
            size="sm"
            className="btn-dark mt-2"
            type="button"
            onClick={onAddNewValueClick}
          >
            Add New Value
          </Button>
        ) : null}
      </div>

      <div
        className={clsx(
          'col-sm-3 col-6',
          listingProfileGridLayout && 'product-listing__more-mapping-grid-mapping-type',
          listingProfileGridLayout && index > 0 && 'product-listing__more-mapping-grid-skip'
        )}
      >
        <div className='row align-items-center'>
          <div className='p-0'>
            <select
              className={mappingTypeSelectClass}
              style={listingProfileGridLayout ? undefined : { height: '39px' }}
              value={attributeMappingOptions}
              onChange={(e) => handleMappingOptionChange(index, e.target.value)}
            >
              <option value='DEFAULT'>Default</option>
              <option value='NATIVE'>Native Field</option>
              <option value='CUSTOM'>Custom Field</option>
            </select>
          </div>
        </div>
      </div>
      {index == 0 ? (
        <>
          <div className={clsx('col-12 col-sm-6', !listingProfileGridLayout && 'mt-2 mt-sm-0')}>
            <div className={clsx(listingProfileGridLayout && 'product-listing__more-mapping-value-cell')}>
              <div
                className={clsx(
                  listingProfileGridLayout
                    ? clsx(
                        'product-listing__more-mapping-value-cell-inner',
                        showMultiAddNewOnThisRow &&
                          'product-listing__more-mapping-value-cell-inner--with-multi-add'
                      )
                    : 'w-100'
                )}
              >
            <div
              className={clsx(
                listingProfileGridLayout
                  ? 'product-listing__more-mapping-value-row'
                  : 'row p-0',
                showMultiAddNewOnThisRow &&
                  'product-listing__more-mapping-value-row--with-multi-add'
              )}
            >
              {attributeMappingOptions === 'DEFAULT' ? (
                <div className={valueFieldWrapClass('col-10 col-sm-8 ms-sm-3  mb-0 ms-sm-0 me-sm-3 ')}>
                  {categoryAttributes.input_type === 'SELECT' && (
               <MoreAttributeForSelect
               platformid={categoryAttributes.id!}
                          attribute={categoryAttributes}
                          selectedValues={selectedValues}
                          val ={values}
                          handleValueChange={handleValueChange}
                          savedOption={optionFromSavedMappingRef(moreTemplateItemData?.value)}
                          useListingProfileFormControls={listingProfileGridLayout}
                        />
                  )}
                     
                  {isDefaultTextValueInput(categoryAttributes.input_type) && (
                    <input
                      type='text'
                      name='value_str'
                      className={valueControlClass('form-control flex-grow-1')}
                      placeholder={categoryAttributes.display_name}
                      value={values?.value_str ? values?.value_str : ''}
                      onChange={handleChange}
                    />
                  )}
                   {categoryAttributes.input_type === 'INTEGER' && (
                    <input
                      type='number'
                      name='value_str'
                      className={valueControlClass('form-control flex-grow-1')}
                      placeholder={categoryAttributes.display_name}
                      // value={values?.value ?  values?.value : 0}
                      value={values?.value_str!==null ? values?.value_str : ''}
                      onChange={handleChange}
                    />)}
                  {categoryAttributes.input_type === 'MULTI_INSTANCE_TEXT' && (
                    <input
                      type='text'
                      name={`template_data[${index}].value_str`}
                      className={valueControlClass('form-control flex-grow-1')}
                      placeholder={categoryAttributes.display_name}
                      value={rowData?.value_str ? rowData?.value_str : ''}
                      onChange={handleChange}
                    />
                  )}
                  {(categoryAttributes.input_type === 'MULTI_INSTANCE_SELECT' || categoryAttributes && categoryAttributes.input_type === 'MULTISELECT') && (
                    <select
                      className={valueControlClass('form-select d-flex flex-wrap flex-grow-1')}
                      name={`template_data[${index}].value`}
                      disabled={dataSetLoading}
                      value={rowData?.value ? rowData?.value : ''}
                      onChange={handleAttributeSelectChange}
                    >
                      <option value="">Select {categoryAttributes.display_name}</option>
                      {platformValueOptions.map((field) => (
                        <option key={field.value} value={field.value}>
                          {field.label}
                        </option>
                      ))}
                    </select>
                  )}

                  {categoryAttributes.input_type === 'MULTILINE_TEXT' && (
                        <>
                        <MappingMultilineHtmlEditor value={rowData.value_str} onChangeData={(val)=>{
                          let shadowTemplate = [...values.template_data]
                          shadowTemplate[index].value_str = val
                          setFormikState(pre=>{
                            return {...pre, values:{ ...pre.values , template_data: shadowTemplate }}
                          })
                        }} />
                        <div>
                        <div className='text-end'>
                          <button type='button' className='btn text-muted text-hover-primary fw-bold mt-1 cursor-pointer' onClick={() => handleShortCode('description')}>
                            <FontAwesomeIcon icon={faPlus} className='me-2' /> See the Options here
                          </button>
                        </div>
                        <div className='text-end w-md-100'>
                        {shortCodeVisibility ? (
                          <div className='text-end'>
                            {shortCode
                              ? shortCode.map((item: any) => {
                                  return (
                                    <Fragment key={item.id}>
                                      <CopyToClipboard text={item.name}>
                                        <Button
                                          size='sm'
                                          variant={copyMarkup && buttonString === item.name ? 'outline-success' : 'outline-primary'}
                                          className={`px-3 py-2 border border-1 m-2 ${
                                            copyMarkup && buttonString === item.name ? 'border-success' : 'border-primary'
                                          } rounded text-hover-white fs-sm-8 inline-block`}
                                          onClick={() => handleCopyMarkup(item.name, 'description')}
                                        >
                                          {copyMarkup && buttonString === item.name ? <span className='fs-sm-8'>Copied !</span> : item.name}
                                        </Button>
                                      </CopyToClipboard>
                                    </Fragment>
                                  );
                                })
                              : null}
                          </div>
                        ) : null}
                        </div>
                        </div>
                      </>
                  )}

                  {categoryAttributes.input_type === 'MULTILINETEXT' && (
                        <>
                        <MappingMultilineHtmlEditor value={rowData.value_str} onChangeData={(val)=>{
                          let shadowTemplate = [...values.template_data]
                          shadowTemplate[index].value_str = val
                          setFormikState(pre=>{
                            return {...pre, values:{ ...pre.values , template_data: shadowTemplate }}
                          })
                        }} />
                        <div>
                        <div className='text-end'>
                          <button type='button' className='btn text-muted text-hover-primary fw-bold mt-1 cursor-pointer' onClick={() => handleShortCode('description')}>
                            <FontAwesomeIcon icon={faPlus} className='me-2' /> See the Options here
                          </button>
                        </div>
                        <div className='text-end w-md-100'>
                        {shortCodeVisibility ? (
                          <div className='text-end'>
                            {shortCode
                              ? shortCode.map((item: any) => {
                                  return (
                                    <Fragment key={item.id}>
                                      <CopyToClipboard text={item.name}>
                                        <Button
                                          size='sm'
                                          variant={copyMarkup && buttonString === item.name ? 'outline-success' : 'outline-primary'}
                                          className={`px-3 py-2 border border-1 m-2 ${
                                            copyMarkup && buttonString === item.name ? 'border-success' : 'border-primary'
                                          } rounded text-hover-white fs-sm-8 inline-block`}
                                          onClick={() => handleCopyMarkup(item.name, 'description')}
                                        >
                                          {copyMarkup && buttonString === item.name ? <span className='fs-sm-8'>Copied !</span> : item.name}
                                        </Button>
                                      </CopyToClipboard>
                                    </Fragment>
                                  );
                                })
                              : null}
                          </div>
                        ) : null}
                        </div>
                        </div>
                      </>
                  )}
                  
                </div>
              ) : (
                <div className={valueFieldWrapClass('col-10 col-sm-8  ms-sm-3 ')}>
                  {categoryAttributes.input_type.includes('MULTI') ? (
                    listingProfileGridLayout ? (
                      renderMappedFieldSearch({
                        name: `template_data[${index}].mapped_field`,
                        value: rowData?.mapped_field ?? '',
                        placeholder: `Select ${categoryAttributes.display_name}`,
                        disabled: dataSetLoading,
                        onChange: handleAttributeSelectChange,
                        wrapClass: 'form-select d-flex flex-wrap me-2 flex-grow-1',
                      })
                    ) : (
                      <select
                        className={valueControlClass('form-select d-flex flex-wrap me-2 flex-grow-1')}
                        name={`template_data[${index}].mapped_field`}
                        value={rowData?.mapped_field ? rowData?.mapped_field : ''}
                        onChange={handleAttributeSelectChange}
                        disabled={dataSetLoading}
                      >
                        <option value="">{dataSetLoading?'Loading...':`Select ${categoryAttributes.display_name}`}</option>
                        {mappedFieldOptions.map((field) => (
                          <option key={field.value} value={field.value}>
                            {field.label}
                          </option>
                        ))}
                      </select>
                    )
                    ) : listingProfileGridLayout ? (
                      renderMappedFieldSearch({
                        name: 'mapped_field',
                        value: values.mapped_field,
                        placeholder: `Select ${categoryAttributes.display_name}`,
                        disabled: dataSetLoading,
                        onChange: (e) => {
                          setFieldValue('mapped_field', e.target.value ? e.target.value : '')
                        },
                      })
                    ) : (
                      <Select
                        id='mappedFieldSelect'
                        isDisabled={dataSetLoading}
                        placeholder={
                          dataSetLoading
                            ? 'Loading...'
                            : `Select ${categoryAttributes.display_name}`
                        }
                        options={mappedFieldOptions}
                        onChange={(selectedOption) => {
                          setFieldValue('mapped_field', selectedOption ? String(selectedOption.value) : '');
                        }}
                        classNamePrefix='react-select'
                        value={mappedFieldOptions.find((opt) => sameMiscOptionId(opt.value, values.mapped_field)) || null}
                        isSearchable
                        isClearable={true}
                        styles={legacyMappedFieldSelectStyles}
                      />
                    )}
                </div>
              )}

              {showMultiAddNewOnThisRow ? (
                <button
                  type="button"
                  className="btn btn-primary btn-sm product-listing__more-mapping-multi-add-btn"
                  onClick={onMultiAddNewClick}
                >
                  + Add New
                </button>
              ) : null}

              {index !== 0 || !listingProfileGridLayout ? (
                <div
                  className={clsx(
                    'col-2',
                    listingProfileGridLayout && 'product-listing__more-mapping-remove-wrap'
                  )}
                >
                  {index !== 0 && (
                    <button
                      className={clsx(
                        'btn btn-outline btn-light-danger text-end',
                        listingProfileGridLayout ? 'ms-2 mt-0 mb-0' : 'ms-4 mt-2 mb-4'
                      )}
                      type='button'
                      disabled={deletingTemplateData}
                      onClick={() => handleRemoveRow(index, rowData.id)}
                    >
                      <FontAwesomeIcon icon={faXmark} />
                    </button>
                  )}
                </div>
              ) : null}
            </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className={clsx('col-12 col-sm-6', !listingProfileGridLayout && 'mt-1 mt-sm-0')}>
            <div className={clsx(listingProfileGridLayout && 'product-listing__more-mapping-value-cell')}>
              <div
                className={clsx(
                  listingProfileGridLayout
                    ? 'product-listing__more-mapping-value-cell-inner'
                    : 'w-100'
                )}
              >
            <div
              className={clsx(
                listingProfileGridLayout
                  ? 'product-listing__more-mapping-value-row'
                  : 'row p-0 ms-sm-1'
              )}
            >
              {attributeMappingOptions === 'DEFAULT' ? (
                <div className={valueFieldWrapClass('col-10 col-sm-8  ms-sm-0  mb-0 ms-sm-0 me-sm-0')}>
                  {categoryAttributes.input_type === 'SELECT' && (
                    <select
                      className={valueControlClass('form-select d-flex flex-wrap flex-grow-1')}
                      name='value'
                      disabled={dataSetLoading}
                      value={values?.value ? values?.value : ''}
                      onChange={handleAttributeSelectChange}
                    >
                      <option value="">Select {categoryAttributes.display_name}</option>
                      {platformValueOptions.map((field) => (
                        <option key={field.value} value={field.value}>
                          {field.label}
                        </option>
                      ))}
                    </select>
                  )}
                  {isDefaultTextValueInput(categoryAttributes.input_type) && (
                    <input
                      type='text'
                      name='value_str'
                      className={valueControlClass('form-control flex-grow-1')}
                      placeholder={categoryAttributes.display_name}
                      value={values?.value_str ? values?.value_str : ''}
                      onChange={handleChange}
                    />
                  )}
                  {categoryAttributes.input_type === 'MULTI_INSTANCE_TEXT' && (
                    <input
                      type='text'
                      name={`template_data[${index}].value_str`}
                      className={valueControlClass('form-control flex-grow-1')}
                      placeholder={categoryAttributes.display_name}
                      value={rowData?.value_str ? rowData?.value_str : ''}
                      onChange={handleChange}
                    />
                  )}
                  {(categoryAttributes.input_type === 'MULTI_INSTANCE_SELECT' || categoryAttributes && categoryAttributes.input_type === 'MULTISELECT') && (
                    <select
                      className={valueControlClass('form-select d-flex flex-wrap flex-grow-1')}
                      name={`template_data[${index}].value`}
                      disabled={dataSetLoading}
                      value={rowData?.value ? rowData?.value : ''}
                      onChange={handleAttributeSelectChange}
                    >
                      <option value="">Select {categoryAttributes.display_name}</option>
                      {platformValueOptions.map((field) => (
                        <option key={field.value} value={field.value}>
                          {field.label}
                        </option>
                      ))}
                    </select>
                  )}
                  {categoryAttributes.input_type === 'MULTILINE_TEXT' && (
                    <>
                      <MappingMultilineHtmlEditor value={rowData.value_str} onChangeData={(val)=>{
                        let shadowTemplate = [...values.template_data]
                        shadowTemplate[index].value_str = val
                        setFormikState(pre=>{
                          return {...pre, values:{ ...pre.values , template_data: shadowTemplate }}
                        })
                      }} />
                      <div>
                      <div className='text-end'>
                        <button type='button' className='btn text-muted text-hover-primary fw-bold mt-1 cursor-pointer' onClick={() => handleShortCode('description')}>
                          <FontAwesomeIcon icon={faPlus} className='me-2' /> See the Options here
                        </button>
                      </div>
                      <div className='text-end w-md-100'>
                      {shortCodeVisibility ? (
                        <div className='text-end'>
                          {shortCode
                            ? shortCode.map((item: any) => {
                                return (
                                  <Fragment key={item.id}>
                                    <CopyToClipboard text={item.name}>
                                      <Button
                                        size='sm'
                                        variant={copyMarkup && buttonString === item.name ? 'outline-success' : 'outline-primary'}
                                        className={`px-3 py-2 border border-1 m-2 ${
                                          copyMarkup && buttonString === item.name ? 'border-success' : 'border-primary'
                                        } rounded text-hover-white fs-sm-8 inline-block`}
                                        onClick={() => handleCopyMarkup(item.name, 'description')}
                                      >
                                        {copyMarkup && buttonString === item.name ? <span className='fs-sm-8'>Copied !</span> : item.name}
                                      </Button>
                                    </CopyToClipboard>
                                  </Fragment>
                                );
                              })
                            : null}
                        </div>
                      ) : null}
                      </div>
                      </div>
                    </>
                  )}
                  {categoryAttributes.input_type === 'MULTILINETEXT' && (
                    <>
                      <MappingMultilineHtmlEditor value={rowData.value_str} onChangeData={(val)=>{
                        let shadowTemplate = [...values.template_data]
                        shadowTemplate[index].value_str = val
                        setFormikState(pre=>{
                          return {...pre, values:{ ...pre.values , template_data: shadowTemplate }}
                        })
                      }} />
                      <div>
                      <div className='text-end'>
                        <button type='button' className='btn text-muted text-hover-primary fw-bold mt-1 cursor-pointer' onClick={() => handleShortCode('description')}>
                          <FontAwesomeIcon icon={faPlus} className='me-2' /> See the Options here
                        </button>
                      </div>
                      <div className='text-end w-md-100'>
                      {shortCodeVisibility ? (
                        <div className='text-end'>
                          {shortCode
                            ? shortCode.map((item: any) => {
                                return (
                                  <Fragment key={item.id}>
                                    <CopyToClipboard text={item.name}>
                                      <Button
                                        size='sm'
                                        variant={copyMarkup && buttonString === item.name ? 'outline-success' : 'outline-primary'}
                                        className={`px-3 py-2 border border-1 m-2 ${
                                          copyMarkup && buttonString === item.name ? 'border-success' : 'border-primary'
                                        } rounded text-hover-white fs-sm-8 inline-block`}
                                        onClick={() => handleCopyMarkup(item.name, 'description')}
                                      >
                                        {copyMarkup && buttonString === item.name ? <span className='fs-sm-8'>Copied !</span> : item.name}
                                      </Button>
                                    </CopyToClipboard>
                                  </Fragment>
                                );
                              })
                            : null}
                        </div>
                      ) : null}
                      </div>
                      </div>
                    </>
                  )}
                </div>
              ) : (
                <div className={valueFieldWrapClass('col-10 col-sm-8  mb-0 ')}>
                  {listingProfileGridLayout ? (
                    renderMappedFieldSearch({
                      name: `template_data[${index}].mapped_field`,
                      value: rowData?.mapped_field ?? '',
                      placeholder: `Select ${categoryAttributes.display_name}`,
                      disabled: dataSetLoading,
                      onChange: handleAttributeSelectChange,
                      wrapClass: 'form-select d-flex flex-wrap me-4 flex-grow-1',
                    })
                  ) : (
                    <select
                      className={valueControlClass('form-select d-flex flex-wrap me-4 flex-grow-1')}
                      name={`template_data[${index}].mapped_field`}
                      value={rowData?.mapped_field ? rowData?.mapped_field : ''}
                      onChange={handleAttributeSelectChange}
                      disabled={dataSetLoading}
                    >
                      <option value="">{dataSetLoading?'Loading...':`Select ${categoryAttributes.display_name}`}</option>
                      {mappedFieldOptions.map((field) => (
                        <option key={field.value} value={field.value}>
                          {field.label}
                        </option>
                      ))}
                    </select>
                  )}
                </div>
              )}

              <div
                className={clsx(
                  'col-2',
                  listingProfileGridLayout && 'product-listing__more-mapping-remove-wrap'
                )}
              >
                {index !== 0 && (
                  <button
                    className={clsx(
                      'btn btn-outline btn-light-danger text-end',
                      listingProfileGridLayout ? 'ms-2 mt-0 mb-0' : 'ms-4'
                    )}
                    type='button'
                    disabled={deletingTemplateData}
                    onClick={() => handleRemoveRow(index, rowData.id)}
                  >
                    <FontAwesomeIcon icon={faXmark} />
                  </button>
                )}
              </div>
            </div>
              </div>
            </div>
          </div>
        </>
      )}
      <AddNewAttributeValueModal
      closeModal = {closeModal}
        categoryAttributes={categoryAttributes}
        isVisible={openAddNewAttributeValueModal}
        allowDataInsertion={allowDataInsertion}
        insertionPayload={insertionPayload}
        setOpenAddNewAttributeValueModal={setOpenAddNewAttributeValueModal}
      />
    </div>
  )
}

export default TemplateMappingItem
